import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

/** Legacy locale prefixes still accepted in URLs for redirects to /de/… */
const legacyLocalePrefixes = ['en', 'de', 'tr'] as const;

export const supportedLocales = ['de'] as const;
export type SupportedLocale = typeof supportedLocales[number];

export function detectLocaleFromPath(_pathname: string): SupportedLocale {
  return 'de';
}

export function getPathWithoutLocale(pathname: string): string {
  const segments = pathname.split('/').filter(Boolean);
  const localeFromPath = segments[0];

  if (localeFromPath && legacyLocalePrefixes.includes(localeFromPath as (typeof legacyLocalePrefixes)[number])) {
    const rest = segments.slice(1).join('/');
    return rest ? `/${rest}` : '/';
  }

  return pathname;
}

/**
 * Berufsrakete is German-only; always return de regardless of URL params.
 */
export function detectLocaleFromUrl(_pathname: string, _search: string = ''): SupportedLocale {
  return 'de';
}

const i18n = i18next
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    lng: 'de',
    fallbackLng: 'de',
    supportedLngs: supportedLocales,
    debug: import.meta.env.DEV,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['path', 'localStorage', 'navigator'],
      lookupFromPathIndex: 0,
      caches: ['localStorage'],
    },
  });

if (import.meta.hot) {
  import.meta.hot.on('locales-update', () => {
    i18next.reloadResources().then(() => {
      i18next.changeLanguage(i18next.language);
    });
  });
}

export default i18n;